import { ServerClient } from 'common/utils/http/http-clients';
import { ICitationMove, ICitationRead, IEditCitationLicensePlate, ILicensePlateDrivingPrivilegesRead } from './citation.service.types';
import { IResponseList } from 'common/models/response-list.interface';

class CitationService {
  async getCitations(
    pageLimit: any,
    filter: string | null | undefined,
    sort: string | null | undefined,
  ): Promise<IResponseList<ICitationRead>> {
    const res = await ServerClient.get<IResponseList<ICitationRead>>('citations', {
      params: {
        filter,
        ...pageLimit,
        sort,
      },
    });
    return res?.data;
  }

  async getByExternalId(externalId: number | string): Promise<ICitationRead> {
    const res = await ServerClient.get(`citations/items/${externalId}`);
    return res?.data;
  }

  async waive(citationItemId: number, residentId: number): Promise<void> {
    const res = await ServerClient.post(`residents/${residentId}/citations/items/${citationItemId}/actions/waive`);
    return res?.data;
  }

  async pause(citationItemId: number, residentId: number): Promise<void> {
    const res = await ServerClient.post(`residents/${residentId}/citations/items/${citationItemId}/actions/pause`);
    return res?.data;
  }

  async resume(citationItemId: number, residentId: number): Promise<void> {
    const res = await ServerClient.post(`residents/${residentId}/citations/items/${citationItemId}/actions/resume`);
    return res?.data;
  }

  async cancel(citationItemId: number, residentId: number): Promise<void> {
    const res = await ServerClient.post(`residents/${residentId}/citations/items/${citationItemId}/actions/cancel`);
    return res?.data;
  }

  async confirmPayment(citationItemId: number, residentId: number): Promise<void> {
    const res = await ServerClient.post(`residents/${residentId}/citations/items/${citationItemId}/actions/paid`);
    return res?.data;
  }

  async approve(citationItemId: number, residentId: number): Promise<void> {
    const res = await ServerClient.post(`residents/${residentId}/citations/items/${citationItemId}/actions/approve`);
    return res?.data;
  }

  async confirm(citationItemId: number, residentId: number): Promise<void> {
    const res = await ServerClient.post(`residents/${residentId}/citations/items/${citationItemId}/actions/confirm`);
    return res?.data;
  }

  async move(citationItemId: number, model: ICitationMove): Promise<ICitationRead> {
    const res = await ServerClient.post(`citations/items/${citationItemId}/move`, model);
    return res?.data;
  }

  async editLicensePlate(citationItemId: number, model: IEditCitationLicensePlate): Promise<ICitationRead> {
    const res = await ServerClient.put(`citations/items/${citationItemId}/license-plate`, model);
    return res?.data;
  }

  async isLicensePlateDrivingPrivilegesRevoked(licensePlate: string): Promise<ILicensePlateDrivingPrivilegesRead> {
    const res = await ServerClient.get(`citations/items/license-plates/${licensePlate}/driving-privileges-revoked`);
    return res?.data;
  }
}

export const citationService = new CitationService();
export default citationService;
